var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticClass: "panel-group", attrs: { gutter: 40 } },
        [
          _c("pagination", {
            attrs: {
              total: _vm.pagination.total,
              page: _vm.pagination.page,
              limit: _vm.pagination.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.pagination, "limit", $event)
              },
              pagination: _vm.handlePagination,
            },
          }),
        ],
        1
      ),
      _vm._l(_vm.chunkSettings(), function (settings, idx) {
        return _c(
          "el-row",
          { key: idx, staticClass: "panel-group", attrs: { gutter: 40 } },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticStyle: { "font-size": "xx-large" } }, [
                      _vm._v(
                        "Week " + _vm._s(parseInt(settings[0].sequence / 7) + 1)
                      ),
                    ]),
                  ]
                ),
                _vm._l(settings, function (setting) {
                  return _c(
                    "el-col",
                    {
                      key: setting.sequence,
                      staticClass: "card-panel-col",
                      attrs: { xs: 12, sm: 12, lg: 6 },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card-panel" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "box-card",
                              attrs: {
                                "body-style":
                                  "padding: 10px; overflow-x: hidden; overflow-y: auto;",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "large" } },
                                    [_vm._v("Day " + _vm._s(setting.sequence))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "filter-item button-corner",
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-edit",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(setting)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("setting.edit")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: setting.missions,
                                    width: "100%",
                                    height: "440px",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "type",
                                      label: "Type",
                                      width: "85",
                                      formatter: _vm.getTypeLabel,
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: { prop: "", label: "", width: "10" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("div", {
                                                class: {
                                                  missionFree:
                                                    _vm.tableRowClassName(
                                                      scope.row
                                                    ),
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { prop: "title", label: "Title" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "inline-block",
                                                    "white-space": "normal",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(scope.row.title) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        )
      }),
      _c("edit", {
        attrs: { visible: _vm.edit.showDialog, setting: _vm.edit.setting },
        on: {
          "update:visible": function ($event) {
            return _vm.$set(_vm.edit, "showDialog", $event)
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }